import { render } from "./BaliseConfig.vue?vue&type=template&id=772bdac2"
import script from "./BaliseConfig.vue?vue&type=script&lang=js"
export * from "./BaliseConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__